module.exports = __webpack_public_path__ + "static/media/barkbliss-5.2af22445.jpg";